"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmButton = void 0;
/* eslint-disable react/button-has-type */
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Loading_1 = require("../Loading");
exports.SmButton = (0, react_1.forwardRef)((_a, ref) => {
    var { icon, className, isOutlined = false, isPill = false, positionIcon = 'left', text = '', variant = 'primary', isUnstyled, isLoading = false, loadingSize = 'large' } = _a, props = __rest(_a, ["icon", "className", "isOutlined", "isPill", "positionIcon", "text", "variant", "isUnstyled", "isLoading", "loadingSize"]);
    const isIconLeft = icon && text && positionIcon === 'left';
    const isIconRight = icon && text && positionIcon === 'right';
    const isIconOnly = icon && !text;
    const buttonClassname = (0, classnames_1.default)('c-button', {
        '-withIcon': icon,
        '-iconOnly': isIconOnly,
        '-outlined': isOutlined,
        '-pills': isPill,
        'flex-row-reverse': isIconRight,
        '-unstyled': isUnstyled,
    }, `-${variant}`, className);
    const buttonIconClassname = (0, classnames_1.default)('d-flex justify-center', {
        'mr-4': isIconLeft,
        'ml-4': isIconRight,
    });
    const buttonContent = react_1.default.useCallback(() => {
        return isIconOnly ? (icon) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: buttonIconClassname }, icon),
            text));
    }, [buttonIconClassname, icon, text]);
    return (react_1.default.createElement("button", Object.assign({}, props, { ref: ref, className: buttonClassname, disabled: isLoading || props.disabled }), isLoading ? (react_1.default.createElement(Loading_1.SmLoading, { type: "secondary", loadingSize: loadingSize })) : (buttonContent())));
});
//# sourceMappingURL=index.js.map